module.exports = __webpack_public_path__ + "img/teselagen.42cac047.png";